import { render, staticRenderFns } from "./LinkFieldtype.vue?vue&type=template&id=945e6f8a&"
import script from "./LinkFieldtype.vue?vue&type=script&lang=js&"
export * from "./LinkFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports